export const reports = (state) => state.reports;
